export const toNumOrUndef = (v) =>
  v === "" || v === null || v === undefined ? undefined : Number(v);
